/**
 * Map an uploaded font's file extension to a CSS @font-face format() hint.
 *
 * iOS Safari is stricter than desktop Chrome: without a format() hint it can
 * refuse to load the file and silently fall back to a system font, which is
 * why a custom TTF/woff2 that rendered on desktop didn't pull through on
 * iPhone. We derive the hint from the stored file extension.
 *
 * Returns a leading-space string ready to append after url(...), e.g.
 * " format('truetype')", or '' when the extension is unknown (better to emit
 * no hint than a wrong one).
 */
export function fontFormatHint(url?: string | null): string {
  if (!url) return '';
  // Drop any query string / hash before reading the extension.
  const path = url.split(/[?#]/)[0].toLowerCase();
  if (path.endsWith('.woff2')) return " format('woff2')";
  if (path.endsWith('.woff')) return " format('woff')";
  if (path.endsWith('.ttf')) return " format('truetype')";
  if (path.endsWith('.otf')) return " format('opentype')";
  return '';
}
